import styled from 'styled-components'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const InvoicePaymentMethods = styled.div`
	margin-top: 0.25em;
	font-size: 0.88em;
	color: ${colorTheme.invoices.table.paymentMethods};
`
InvoicePaymentMethods.displayName = 'InvoicePaymentMethods'
